<template>
  <div class="copyright">
    {{ copyright }}
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      copyright: `© ${moment().format('YYYY')} Studio Classroom`
    }
  }
}
</script>